import React from 'react'
import { useDrop } from 'react-dnd'
import { withRouter } from 'react-router'
import get from 'lodash/get'
import { useImgLink } from 'components/Image'
import Cell from './Cell'

const ProductCell = ({ history, data, currency, readOnly, previewMode, previewWithPrice, cellNum, onRemove, onDrop }) => {
	const [, dropTargetRef] = useDrop({
		accept: 'row',
		drop(item, monitor) {
    	if(!readOnly && onDrop) {
				onDrop(cellNum, monitor.getItem())
			}
		}
	})

	const { src } = useImgLink({ imgKey: get(data, 'product.img.key') })

	const removeCell = (e) => {
		e.stopPropagation()
		if(onRemove) {
			onRemove(cellNum)
		}
	}

	const handleClick = () => {
		history.push(`/artikel/${data.product.id}`)
	}

	let cellProps = data && data.product ? {
		src,
		currency,
		dropTargetRef,
		...!readOnly && { onRemove: removeCell },
		onClick: handleClick,
		name: data.product.name,
		code: data.product.code,

		price: data.product.price ? data.product.price[0]?.toFixed(2) : '',
		borderColor: data.product.category && data.product.category.color
	} : {
		dropTargetRef,
		noData: true
	}

	return <Cell {...cellProps}/>
}

export default withRouter(ProductCell)
